import React, { useState, useRef, useEffect } from "react";
import PropTypes from 'prop-types';
import { useIdleTimer } from "react-idle-timer";
import { useAuth0 } from "@auth0/auth0-react";
import { Modal, Box, Typography } from "@mui/material";
import CustomButton from '../common/CustomButton/CustomButton';
const IDLE_TIMEOUT = 45 * 60 * 1000; // 45 minutes
const WARNING_COUNTDOWN = 10;       // 10 sec countdown

const IdleTimerProvider = ({ children }) => {
    const {isAuthenticated,getAccessTokenSilently, logout } = useAuth0();
    const [open, setOpen] = useState(false);
    const [countdown, setCountdown] = useState(WARNING_COUNTDOWN);
    const countdownRef = useRef(null);

    const handleOnIdle = () => {
        setOpen(true);
        setCountdown(WARNING_COUNTDOWN);

        countdownRef.current = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(countdownRef.current);
                    logout({ returnTo: window.location.origin });
                }
                return prev - 1;
            });
        }, 1000);
    };
    const handleStay = async () => {
        try {
            setOpen(false);
            clearInterval(countdownRef.current);
            if (isAuthenticated) {
                const token = await getAccessTokenSilently(
                //     {
                //     ignoreCache: true,
                //     cacheMode: "off"
                // }
            );
                 if (token){
 reset();
            }
            }
        } catch (err) {
            console.error('Silent token renewal failed:', err);
        }
    };
    const handleLogoutNow = () => {
        clearInterval(countdownRef.current);
        logout({ returnTo: window.location.origin });
    };

    const { reset } = useIdleTimer({
        timeout: IDLE_TIMEOUT,
        onIdle: handleOnIdle,
        debounce: 500,
    });

    useEffect(() => {
        return () => clearInterval(countdownRef.current);
    }, []);

    return (
        <>
            {children}
            <Modal open={open}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 200,
                        p: 3,
                        bgcolor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 24,
                        textAlign: "center",
                    }}
                >
                    <Typography variant="h6" sx={{ mb: 2, fontFamily: 'Nunito Sans', lineHeight: '1', fontSize: '1rem' }}>
                        Session Expiring
                    </Typography>
                    <Typography sx={{ mb: 2, fontFamily: 'Nunito Sans', fontSize: '0.875rem' }}>
                        You will be logged out in <strong>{countdown}</strong> seconds.
                    </Typography>
                    <CustomButton handleClick={handleStay} label="Stay Signed In" buttonStyle="idleTimer-filled" disabled={false} />
                    <CustomButton handleClick={handleLogoutNow} label="Logout Now" buttonStyle="idleTimer-white" disabled={false} />
                </Box>
            </Modal>
        </>
    );
}


IdleTimerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};


export default IdleTimerProvider;